import React from 'react';
import {
  Accordion,
} from 'react-accessible-accordion';
import PropTypes from 'prop-types';
import { StyledSummary } from './resultsStyles';
import FAQuestion from '../landing/FAQuestion';
import 'react-accessible-accordion/dist/minimal-example.css';

const CurrentSituation = ({ title, content }) => (
  <Accordion accordion={false} style={{ width: '100%', marginBottom: '10px', maxWidth: '750px' }}>
    <FAQuestion
      question={{
        question: title,
        answer:
          // eslint-disable-next-line react/jsx-indent
          <StyledSummary>
            {content}
          </StyledSummary>,
      }}
      borderBottom
    />
  </Accordion>
);


CurrentSituation.propTypes = {
  title: PropTypes.string,
  content: PropTypes.object,
};

CurrentSituation.defaultProps = {
  title: '',
  content: {},
};


export default CurrentSituation;
